import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-plain-text-popup",
  templateUrl: "./plain-text-popup.html",
  styleUrls: ["./plain-text-popup.scss"],
  standalone: false
})
export class PlainTextPopupComponent {
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  closePopup(): void {
    this.close.emit();
  }
}